import React from 'react'

const ComingSoon = () => {
    return (
        <div className="container">
            <div className="row justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <div className="col-12 col-md-6 text-center">
                    <h6 className="text-uppercase text-body-secondary mb-3">🚧 Under Construction</h6>
                    <h1 className="display-4 fw-bold mb-4">Coming Soon</h1>
                    <p className="text-body-secondary mb-4">
                        We’re working hard to bring you something amazing. Stay tuned!
                    </p>
                    <a href="/dashboard" className="btn btn-lg btn-primary">
                        Return to Home
                    </a>
                </div>
            </div>
        </div>

    )
}

export default ComingSoon